import React from 'react';
import { Button, Card, Col, Row, Image, Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // Import Helmet for SEO
import { COLORS } from '../../constants/colors';

function ProductByCategory({ product }) {
  const endDate = new Date(product.endDate);
  const startDate = new Date(product.startDate);
  const formattedEndDate = endDate.toLocaleDateString();
  const today = new Date();

  // Determine auction status
  const isLive = startDate <= today && endDate > today;
  const isUpcoming = startDate > today;
  const isEnded = endDate <= today;

  // Default fallback image URL (using logo as the default image)
  const defaultImage = 'https://pigeonauction.co.za/images/logo.png';

  const renderImages = () => {
    return product.images.length > 0
      ? product.images.map((image) => (
          <Carousel.Item key={image.id}>
            <Image className="d-block w-100" src={image.image} alt="Product Image" height={200} fluid />
          </Carousel.Item>
        ))
      : null;
  };

  // Dynamically set the page title and meta tags using Helmet
  return (
    <>
      <Helmet>
        {/* Set the title dynamically based on the product name */}
        <title>{`${product.name} - Pigeon Auction`}</title>
        <meta
          name="description"
          content={`Bid on ${product.name} in the ${product.category} category on Pigeon Auction. Current highest bid: R${product.currentHighestBid}`}
        />
        <meta property="og:title" content={`${product.name} - Pigeon Auction`} />
        <meta
          property="og:description"
          content={`Bid on ${product.name} in the ${product.category} category on Pigeon Auction. Current highest bid: R${product.currentHighestBid}`}
        />
        <meta property="og:url" content={`https://pigeonauction.co.za/product/${product.slug}-p-${product._id}`} />
        <meta property="og:type" content="product" />
        <meta
          property="og:image"
          content={product.images.length > 0 ? product.images[0].image : defaultImage}
        />
      </Helmet>

      <Card className="product-card p-3 my-3 shadow border-0">
        <Col className="card-image">
          <Link to={`/product/${product.slug}-p-${product._id}`}>
            {product.images.length === 1 ? (
              <Image
                className="d-block w-100"
                src={product.images[0].image || defaultImage}
                alt="Product Image"
                height={200}
                fluid
              />
            ) : (
              <Carousel className="carousel-custom" variant="dark" interval={null}>
                {renderImages()}
                {/* If no images, display the default logo image */}
                {product.images.length === 0 && (
                  <Carousel.Item>
                    <Image
                      className="d-block w-100"
                      src={defaultImage}
                      alt="Default Product Image"
                      height={200}
                      fluid
                    />
                  </Carousel.Item>
                )}
              </Carousel>
            )}
          </Link>
        </Col>
        <Card.Body>
          <Link className="link-dark text-decoration-none" to={`/product/${product.slug}-p-${product._id}`}>
            <Col className="card-title fw-bold text-center">
              {product.name.substring(0, 30)}{product.name.length > 30 ? '...' : ''}
            </Col>
          </Link>
          <hr />
          <Col className="mb-3">
            {product.currentHighestBid !== 0 ? (
              <Row>
                <Col className="card-text feature text-start text-md-center fw-semibold col-4 col-md-12">
                  Current max bid:
                </Col>
                <Col className="card-text text-end text-md-center">
                  R{product.currentHighestBid}
                </Col>
              </Row>
            ) : (
              <Row>
                <Col className="card-text feature text-start text-md-center fw-semibold col-4 col-md-12">
                  Starting bid:
                </Col>
                <Col className="card-text text-end text-md-center">
                  R{product.price}
                </Col>
              </Row>
            )}
            {isEnded ? (
              <Row>
                <Col className="card-text feature text-start text-md-center fw-semibold col-4 col-md-12">
                  Ended at:
                </Col>
                <Col className="card-text text-end text-md-center">
                  {formattedEndDate}
                </Col>
              </Row>
            ) : (
              <Row>
                <Col className="card-text feature text-start text-md-center fw-semibold col-4 col-md-12">
                  {isUpcoming ? 'Starts at:' : 'Ends at:'}
                </Col>
                <Col className="card-text text-end text-md-center">
                  {formattedEndDate}
                </Col>
              </Row>
            )}
          </Col>
          <Col className="d-flex justify-content-center">
            <Link to={`/product/${product.slug}-p-${product._id}`} className="w-100">
              <Button 
                style={{ backgroundColor: COLORS.SAGE_GREEN, borderColor: COLORS.WARM_CONCRETE }}
                className='w-100'
              >
                {isLive ? 'Place Bid' : 'Details'}
              </Button>
            </Link>
          </Col>
        </Card.Body>
      </Card>
    </>
  );
}

export default ProductByCategory;
